<template>
  <div class="analysis">
    <tree :form="form" ref="tree"></tree>
    <a-card>
      <a-button
        slot="extra"
        type="primary"
        @click="$refs.tree.add()"
        :loading="loading"
      >
        杜邦分析查看
      </a-button>
      <div class="search">
        年份选择：
        <a-date-picker
          :value="form.year"
          mode="year"
          :open="isOpen"
          format="YYYY"
          placeholder="开始年"
          @openChange="handleOpenChange"
          @panelChange="handlePanelChange"
          @change="handleChange"
        />
        <a-button
          class="export-button"
          type="primary"
          slot="extra"
          @click="$refs.cardTable._getChartList()"
        >
          查询
        </a-button>
      </div>
    </a-card>
    <tab-view :form="form" ref="cardTable"></tab-view>
  </div>
</template>

<script>
import TabView from './components/TabView'
import Tree from './components/Tree'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  components: {
    TabView,
    Tree,
  },
  data() {
    return {
      isOpen: false,
      visible: false,
      top: 100,
      form: {
        year: moment(new Date()).format('YYYY'),
        customerCode: '',
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters('app', ['company']),
  },
  mounted() {
    this.form.customerCode = this.company.code
  },
  methods: {
    handleChange() {
      this.form.year = null
    },
    handleOpenChange(status) {
      this.isOpen = status
    },
    //杜邦分析查看
    dbClick() {},
    handlePanelChange(value) {
      this.form.year = moment(value).format('YYYY')
      this.isOpen = false
    },
  },
}
</script>

<style scoped lang="less">
.analysis {
  position: relative;
  width: 100%;
  background-color: #f0f2f5;
  /deep/ .margin-bottom-30 {
    margin-bottom: 30px;
  }
  /deep/ .margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .message-affix {
    position: absolute;
    right: 0;
    top: 20px;
  }
  /deep/ .ant-affix {
    right: 0;
  }
}
.segmentation {
  margin: 0 20px;
}
.export-button {
  margin-left: 30px;
  position: relative;
  top: -1px;
}

/deep/ .ant-card {
  margin-bottom: 20px;
}
</style>
